import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_delete",
  "use": "icon-icon_delete-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-icon_delete\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path d=\"M25.5 9H33v3h-3v19.5a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 6 31.5V12H3V9h7.5V4.5A1.5 1.5 0 0 1 12 3h12a1.5 1.5 0 0 1 1.5 1.5V9Zm1.5 3H9v18h18V12Zm-13.5 4.5h3v9h-3v-9Zm6 0h3v9h-3v-9ZM13.5 6v3h9V6h-9Z\" fill=\"#999\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol